import { HttpClient, HttpResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment.development';
import { FarmRegisterRequestBody } from '../../models/types';

@Injectable({
  providedIn: 'root'
})
export class FarmRegisterService {

  constructor(private http: HttpClient) { }

  registerFarm(farmData: FarmRegisterRequestBody): Observable<any> {
    return this.http.post(environment.registerFarmURL, farmData, {observe: "response"});
  }
}
